import FileUploadIcon from '@mui/icons-material/FileUpload';
import { Box, Button } from '@mui/material';
import React from 'react';
import { FormattedMessage } from 'react-intl';

interface LocalFilesUploadButtonProps {
    onFilesChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

const LocalFilesUploadButton = ({
    onFilesChange,
}: LocalFilesUploadButtonProps) => {
    return (
        <Box display="flex" gap={1} justifyContent="center">
            <Button
                variant="outlined"
                htmlFor="uploadDicomInput"
                endIcon={<FileUploadIcon />}
                component="label"
                fullWidth
            >
                <FormattedMessage id="loadFiles" />
                <input
                    id="uploadDicomInput"
                    data-testid="uploadDicomInput"
                    onChange={onFilesChange}
                    type="file"
                    hidden
                    multiple
                    accept=".dcm,.dicom,.dc3,application/dicom,.gz,.dcm.gz"
                />
            </Button>
        </Box>
    );
};

export default LocalFilesUploadButton;
